import { MeetHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const getClubMeetsData = (orgUnitId, reportPeriodId, state, setState) => {
  if (state.isArrayLoading !== true && orgUnitId && reportPeriodId > 0 && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/Meet/OrgUnit/TeamMeet?orgUnitId=${orgUnitId}&reportPeriodId=${reportPeriodId}`;
    MeetHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  };
};

export default getClubMeetsData;